import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import { RowDataCompleted, RedesignReasons, CompOrderFilterData } from 'src/reducers/completeorderfile';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import {
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    DialogProps,
    FormControlLabel,
    withStyles,
    Typography,
    Radio,
    RadioGroup,
    Badge,
    Box
} from '@material-ui/core';
// import Input from '@material-ui/core/Input';
// import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RedoIcon from '@material-ui/icons/Redo';
// import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
// import StarHalfIcon from '@material-ui/icons/StarHalf';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import { UserDetail } from 'src/reducers/user';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { defaultDesignReadyData, maxDayCount } from 'src/actions/completeOrderAction';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@material-ui/core';

interface TableStateDate {
    columns: Array<Column<RowDataCompleted>>;
    data: RowDataCompleted[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

const defaultFilterData: CompOrderFilterData = {
    pdownload: 'all',
    pqc_required: 'all',
    prange: 'Current Week',
    fdate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    tdate: new Date()
};

export interface CompleteOrderPageViewDateProps {
    completeOrderData: RowDataCompleted[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    // onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    // onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted, isRetry?: boolean) => void;
    onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted, isRetry?: boolean) => void;
    printClient: (completedData: RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    // onFileName:(fileName: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;

    userInfo: UserDetail;

    redirectDesignReady: Boolean;

    onFilterChange: (data: CompOrderFilterData) => void;
    // Add these new properties:
    // failedFiles: Array<{ fname: string; orderno: string }>;
    // failedFiles: Array<{ fname: string; orderno: string; fileType?: string }>;
    failedFiles: Array<{ fname: string; orderno: string; fileType?: string; caseCount?: number }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        reasonBox: {
            minWidth: '500px'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        svg: {
            maxHeight: '20px'
        },
        svgOutline: {
            cursor: 'pointer',
            padding: '12px',
            flex: '0 0 auto',
            color: 'rgba(0, 0, 0, 0.54)',
            overflow: 'visible',
            fontSize: '1.5rem',
            textAlign: 'center',
            borderRadius: '50%',
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
        },
        radioButtonStyle: {
            fontSize: '0.8rem'
        },
        // Add these new styles
        // failedFilesContainer: {
        //     marginTop: theme.spacing(2),
        // },
        tableContainer: {
            maxHeight: 300,
            marginTop: theme.spacing(1),
        },
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
            fontSize: '0.9rem'
        },
    },
})(TextField);

// const StyledMenu = withStyles({
//     paper: {
//         border: '1px solid #d3d4d5',
//     },
// })((props: MenuProps) => (
//     <Menu
//         elevation={0}
//         getContentAnchorEl={null}
//         anchorOrigin={{
//             vertical: 'bottom',
//             horizontal: 'center',
//         }}
//         transformOrigin={{
//             vertical: 'top',
//             horizontal: 'center',
//         }}
//         {...props}
//     />
// ));

// const StyledMenuItem = withStyles(theme => ({
//     root: {
//         '&:focus': {
//             backgroundColor: theme.palette.primary.main,
//             '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
//                 color: theme.palette.common.white,
//             },
//         },
//     },
// }))(MenuItem);

const CompleteOrderPageViewDate: React.StatelessComponent<CompleteOrderPageViewDateProps> = (props) => {
    
    const classes = useStyles({});

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('md');

    const [fullWidthDownload] = React.useState(true);
    const [maxWidthDownload] = React.useState<DialogProps['maxWidth']>('sm');

    const [tat, setTat] = React.useState('Next Day 7 AM');

    const [manufactType, saveManufactType] = React.useState('In-House');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');

    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [userName, setuserName] = React.useState('');

    // const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };
    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    // const duplicatePtype = (data: RedesignReasons[]) => {
    //     return Array.from(new Set(data.map(a => a.producttype)))
    //         .map(id => {
    //             return data.find(a => a.producttype === id);
    //         });
    // };

    const [downIndi, setDownIndi] = React.useState(false);

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = (ordernumber: string, uname: string, dest: string) => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(ordernumber);
        saveManufactType(dest);
        // saveManufactType(dest || 'In-House');
        setuserName(uname);
        setTat('Next Day 7 AM');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };
    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                destination: manufactType,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(5);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<RowDataCompleted[]>([]);

    const handleSelectAll = (tableData: RowDataCompleted[]) => {
        setSelectedRowsArray(tableData.slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: RowDataCompleted) => {

        if (tableData.orderno) {
            setSelectedRowsArray((items: RowDataCompleted[]) => {
                if (items.find(_d => _d.orderno === tableData.orderno)?.orderno) {
                    return items.filter((item) => item.orderno !== tableData.orderno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [downloadType, setDownloadType] = React.useState('multiple');

    const openDownloadDialog = (rowdata: RowDataCompleted[] | RowDataCompleted, type: String) => {
        if (type === 'zip' && selectedRowsArray.length === 1) {
            props.onBulkDownload(selectedRowsArray);
        } else {
            if (type === 'zip') { setDownIndi(true); setDownloadType('multiple'); } else { setDownIndi(false); }
            setFileTypes([]);
            setOpenDownload(true);
        }
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(selectedRowsArray, fileTypes.toString());
    };
    const submitZipDownload = () => {
        setOpenDownload(false);
        if (downloadType === 'single') {
            props.onBulkDownload(selectedRowsArray);
        } else {
            props.onBulkDownloadIndividual(selectedRowsArray);
        }
    };

    const [state] = React.useState<TableStateDate>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px'
                }
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '0px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Received',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                }
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px'
                }
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px'
                }
            },
            {
                title: 'Completed On',
                field: 'completedon',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                // cellStyle: {
                //   backgroundColor: '#039be5',
                //   color: '#FFF'
                // },
                render: rowData => (
                    <div style={{ display: 'flex' }}>
                        {props.userInfo.labCode === '05033' && <Tooltip title="Print Client" placement="top">
                            <div className={classes.svgOutline}>
                                <img src="/assets/svg/3dprinting.png" onClick={() => props.printClient(rowData)} alt="3D Print" className={classes.svg} />
                            </div>
                        </Tooltip>}
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Re-Design" placement="top">
                            <IconButton aria-label="view" onClick={() => handleClickOpenRe(rowData.orderno, rowData.labname, rowData.destination)}>
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {
                            rowData.feedback === '0' ? (
                                <Tooltip title="Pending for Feedback" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() =>
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'black', fontSize: 25 }} /> {/* Question Mark Star */}
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '1' ? (
                                <Tooltip title="Completed" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() =>
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'green', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '2' ? (
                                <Tooltip title="Pending for Review" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() =>
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'blue', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '3' ? (
                                <Tooltip title="Review Completed" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() =>
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'orange', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : null
                        }
                        {rowData.fdownload === '0' ?
                            <Tooltip title="Not yet Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'red', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                            :
                            <Tooltip title="Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'green', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                        }
                        {
                            (parseInt(rowData.msgcnt, 10) && parseInt(rowData.msgcnt, 10) > 0) ?
                                <IconButton aria-label="msg" disabled>
                                    <Badge color="secondary" variant="dot">
                                        <MailOutlineIcon fontSize="small" />
                                    </Badge>
                                </IconButton>
                                : null
                        }
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.completeOrderData
    });

    const [filterOpen, setFilterOpen] = React.useState(false);
    const [filterData, setFilterData] = React.useState<CompOrderFilterData>(props.redirectDesignReady ? defaultDesignReadyData : defaultFilterData);

    const handleChangeFilterData = (fpdownload: string, fprange: string, ffdate: Date, ftdate: Date, qcRequired: string) => {
        if (fprange !== 'Custom') {
            ffdate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
            ftdate = new Date();
        }
        if (fprange === 'Custom' && ffdate > ftdate) {
            setFilterData({
                pdownload: fpdownload,
                prange: fprange,
                fdate: ftdate,
                tdate: ffdate,
                pqc_required: qcRequired
            });
        } else {
            setFilterData({
                pdownload: fpdownload,
                prange: fprange,
                fdate: ffdate,
                tdate: ftdate,
                pqc_required: qcRequired
            });
        }
    };

    const submitFilter = () => {
        setFilterOpen(false);
        props.onFilterChange(filterData);
    };
    const resetFilter = () => {
        setFilterData(defaultFilterData);
    };

    // Add these new state variables in the component
    const [selectedFailedFiles, setSelectedFailedFiles] = React.useState<Array<{ fname: string; orderno: string }>>([]);

    // Add these handler functions
    const handleFailedFileCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, file: { fname: string; orderno: string }) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...selectedFailedFiles, file]);
        } else {
            setSelectedFailedFiles(selectedFailedFiles.filter(item =>
                !(item.fname === file.fname && item.orderno === file.orderno)
            ));
        }
    };

    const handleSelectAllFailedFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...props.failedFiles]);
        } else {
            setSelectedFailedFiles([]);
        }
    };
    // React.useEffect(
    //     () => {
    //         if (props.showFailedFilesDialog) {
    //             setSelectedFailedFiles([]);
    //         }
    //     },
    //     [props.showFailedFilesDialog]
    // );
    // const handleRetryDownload = () => {
    //     if (selectedFailedFiles.length > 0) {
    //         // Create a new array of RowDataCompleted objects from the selected failed files
    //         const filesToDownload = props.completeOrderData.filter(item =>
    //             selectedFailedFiles.some(file =>
    //                 file.fname === item.fname && file.orderno === item.orderno
    //             )
    //         );

    //         // Close the dialog
    //         props.closeFailedFilesDialog();

    //         // Trigger the download for selected files
    //         if (filesToDownload.length > 0) {
    //             props.onBulkDownloadIndividual(filesToDownload, true);
    //         }
    //     }
    // };
    // const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});

    // // Initialize retry counts when failed files dialog opens
    // React.useEffect(
    //     () => {
    //         if (props.showFailedFilesDialog) {
    //             // Reset selected files
    //             setSelectedFailedFiles([]);
                
    //             // Initialize retry counts for any new files
    //             const newRetryCountMap = {...retryCountMap};
    //             props.failedFiles.forEach(file => {
    //                 const fileKey = `${file.orderno}-${file.fname}`;
    //                 if (newRetryCountMap[fileKey] === undefined) {
    //                     newRetryCountMap[fileKey] = 0;
    //                 }
    //             });
    //             setRetryCountMap(newRetryCountMap);
    //         }
    //     },
    //     [props.showFailedFilesDialog, props.failedFiles]
    // );

    // // Modify the handleRetryDownload function to track retry counts
    // const handleRetryDownload = () => {
    //     if (selectedFailedFiles.length > 0) {
    //         // Update retry counts for selected files
    //         const updatedRetryCountMap = {...retryCountMap};
    //         selectedFailedFiles.forEach(file => {
    //             const fileKey = `${file.orderno}-${file.fname}`;
    //             updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
    //         });
    //         setRetryCountMap(updatedRetryCountMap);
            
    //         // Create filtered list with only files that haven't exceeded retry limit
    //         const filesToDownload = props.completeOrderData.filter(item =>
    //             selectedFailedFiles.some(file => {
    //                 const fileKey = `${file.orderno}-${file.fname}`;
    //                 const retryCount = updatedRetryCountMap[fileKey] || 0;
    //                 return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
    //             })
    //         );

    //         // Close the dialog
    //         props.closeFailedFilesDialog();

    //         // Trigger the download for selected files
    //         if (filesToDownload.length > 0) {
    //             props.onBulkDownloadIndividual(filesToDownload, true);
    //         }
    //     }
    // };

    // // Helper function to check if a file has exceeded retry limit
    // const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
    //     const fileKey = `${file.orderno}-${file.fname}`;
    //     return (retryCountMap[fileKey] || 0) >= 3;
    // };

    // // Helper function to get number of retries for a file
    // const getRetryCount = (file: { fname: string; orderno: string }): number => {
    //     const fileKey = `${file.orderno}-${file.fname}`;
    //     return retryCountMap[fileKey] || 0;
    // };
    // Add this to your component state
    const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});

    // Initialize retry counts when failed files dialog opens
    // React.useEffect(
    //     () => {
    //         if (props.showFailedFilesDialog) {
    //             // Reset selected files
    //             setSelectedFailedFiles([]);
                
    //             // Initialize retry counts for any new files
    //             const newRetryCountMap = {...retryCountMap};
    //             props.failedFiles.forEach(file => {
    //                 const fileKey = `${file.orderno}-${file.fname}`;
    //                 if (newRetryCountMap[fileKey] === undefined) {
    //                     newRetryCountMap[fileKey] = 0;
    //                 }
    //             });
    //             setRetryCountMap(newRetryCountMap);
    //         }
    //     },
    //     [props.showFailedFilesDialog, props.failedFiles]
    // );
    // Modify the useEffect that runs when the dialog opens
    React.useEffect(
        () => {
        if (props.showFailedFilesDialog) {
            // Initialize retry counts for any new files
            const newRetryCountMap = {...retryCountMap};
            props.failedFiles.forEach(file => {
            const fileKey = `${file.orderno}-${file.fname}`;
            if (newRetryCountMap[fileKey] === undefined) {
                newRetryCountMap[fileKey] = 0;
            }
            });
            setRetryCountMap(newRetryCountMap);
            
            // Automatically select all files that haven't exceeded retry limit
            const availableFiles = props.failedFiles.filter(file => {
            const fileKey = `${file.orderno}-${file.fname}`;
            return (newRetryCountMap[fileKey] || 0) < 3;
            });
            
            // Set the selected files
            setSelectedFailedFiles(availableFiles);
        }
        },
        [props.showFailedFilesDialog, props.failedFiles]
    );

    // Modify the handleRetryDownload function to track retry counts
    const handleRetryDownload = () => {
        if (selectedFailedFiles.length > 0) {
            // Update retry counts for selected files
            const updatedRetryCountMap = {...retryCountMap};
            selectedFailedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
            });
            setRetryCountMap(updatedRetryCountMap);
            
            // Create filtered list with only files that haven't exceeded retry limit
            const filesToDownload = props.completeOrderData.filter(item =>
                selectedFailedFiles.some(file => {
                    const fileKey = `${file.orderno}-${file.fname}`;
                    const retryCount = updatedRetryCountMap[fileKey] || 0;
                    return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
                })
            );
            props.closeFailedFilesDialog();            
            // if (filesToDownload.length > 0) {
            //     props.onBulkDownloadIndividual(filesToDownload, true);
            // }

            if (filesToDownload.length > 0) {
              if (downloadType === 'single') {
                props.onBulkDownload(filesToDownload, true); 
              } else {
                props.onBulkDownloadIndividual(filesToDownload, true); 
              }
            }
        }
    };

    // Helper function to check if a file has exceeded retry limit
    const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return (retryCountMap[fileKey] || 0) >= 3;
    };

    // Helper function to get number of retries for a file
    const getRetryCount = (file: { fname: string; orderno: string }): number => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return retryCountMap[fileKey] || 0;
    };
    
    // const formatFileSize = (bytes: number): string => {
    //     if (bytes === 0) {
    //       return '0 Bytes';
    //     }
        
    //     const k = 1024;
    //     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    //     const i = Math.floor(Math.log(bytes) / Math.log(k));
        
    //     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    //   };
    // const calculateTotalFileSize = (files: { filesize: string | number }[]): string => {
    //     if (!files || !files.length || !files[0].filesize) {
    //       return 'Size not available';
    //     }
    //     const totalBytes = files.reduce((sum, file) => sum + (typeof file.filesize === 'string' ? parseInt(file.filesize, 10) || 0 : isNaN(file.filesize) ? 0 : file.filesize), 0);
    //     return formatFileSize(totalBytes);
    //   };
    // const caseCount = props?.failedFiles?.length > 0 ? props.failedFiles[0].caseCount : 0;
      
    const stfFailedFiles = props.failedFiles.filter(file => file.fileType === 'STL');
     
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={() => setFilterOpen(true)}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={filterOpen}
                            maxWidth="sm"
                            fullWidth
                            onClose={() => setFilterOpen(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title"><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Filter</Typography></DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item sm={6}>
                                        <Typography variant="body1">Download Status</Typography>
                                        <br />
                                        <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-fds"
                                                id="D-status"
                                                onChange={
                                                    (event) => handleChangeFilterData(event.target.value as string, filterData.prange, filterData.fdate, filterData.tdate, filterData.pqc_required)
                                                }
                                                value={filterData.pdownload}
                                            >
                                                {/* <MenuItem disabled value="">
                                                    <em>Download Status</em>
                                                </MenuItem> */}
                                                <MenuItem value="Not Downloaded">Not Downloaded</MenuItem>
                                                <MenuItem value="Downloaded">Downloaded</MenuItem>
                                                <MenuItem value="all">All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography variant="body1">QC Required</Typography>
                                        <br />
                                        <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-fds"
                                                id="D-status"
                                                onChange={
                                                    (event) => handleChangeFilterData(filterData.pdownload, filterData.prange, filterData.fdate, filterData.tdate, event.target.value as string)
                                                }
                                                value={filterData.pqc_required}
                                            >
                                                <MenuItem value="all">All</MenuItem>
                                                <MenuItem value="yes">Yes</MenuItem>
                                                <MenuItem value="no">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <br />
                                <hr />
                                <Typography variant="body1">Completed On</Typography>
                                <br />
                                <Grid container spacing={2}>
                                    <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                        <Select
                                            labelId="demo-simple-select-outlined-labefsd"
                                            id="range"
                                            value={filterData.prange}
                                            onChange={
                                                (event) => handleChangeFilterData(filterData.pdownload, event.target.value as string, filterData.fdate, filterData.tdate, filterData.pqc_required)
                                            }
                                        >
                                            <MenuItem value="Today">Today</MenuItem>
                                            <MenuItem value="Yesterday">Yesterday</MenuItem>
                                            <MenuItem value="Current Week">Current Week</MenuItem>
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="Custom">Custom</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {filterData.prange === 'Custom' &&
                                    <>
                                        <br />
                                        <hr />
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <Grid container justify="space-around" spacing={2}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    minDate={new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))}
                                                    maxDate={new Date()}
                                                    id="date-picker-dialog"
                                                    label="Start Date"
                                                    format="MM/dd/yyyy"
                                                    value={filterData.fdate}
                                                    name="fdate"
                                                    onChange={(date: Date) => handleChangeFilterData(filterData.pdownload, filterData.prange, date, filterData.tdate, filterData.pqc_required)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                />
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    minDate={new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))}
                                                    maxDate={new Date()}
                                                    id="date-picker-dialog-2"
                                                    label="End Date"
                                                    format="MM/dd/yyyy"
                                                    name="tdate"
                                                    value={filterData.tdate}
                                                    onChange={(date: Date) => handleChangeFilterData(filterData.pdownload, filterData.prange, filterData.fdate, date, filterData.pqc_required)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    helperText={
                                                        maxDayCount(filterData.fdate, filterData.tdate) &&
                                                        filterData.prange === 'Custom' &&
                                                        'Data not more than a week'
                                                    }
                                                />
                                            </Grid>
                                        </MuiPickersUtilsProvider>
                                    </>
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitFilter}
                                    disabled={maxDayCount(filterData.fdate, filterData.tdate) && filterData.prange === 'Custom'}
                                >
                                    Submit
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={resetFilter}
                                    className={classes.HeadinG}
                                >
                                    Reset
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        {/* <Tooltip title="Export" placement="top" arrow>
                            <Button
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClick}
                                className={classes.buttonSend}
                            >
                                <NoteAddOutlinedIcon />
                            </Button>
                        </Tooltip> */}

                        {/* <Dialog
                            open={props.showFailedFilesDialog}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold', color: 'red' }}>
                                    Download Failed Files
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                            {console.log(props, 'propspropspropspropspropspropsprops')
                            }
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Typography variant="subtitle1" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                                            Files Not Found: {props.failedFiles?.length}
                                        </Typography>

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />

                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    checked={selectedFailedFiles.some(item =>
                                                                        item.fname === file.fname && item.orderno === file.orderno
                                                                    )}
                                                                    onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                    color="primary"
                                                                />
                                                            </TableCell>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleRetryDownload}
                                    color="primary"
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0}
                                >
                                    Retry Download
                                </Button>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog> */}
{/*                         
                        <Dialog
                            open={props.showFailedFilesDialog}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold', }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                            Total: {props.failedFiles?.length}
                                        </Typography>
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell>Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);
                                                        
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item =>
                                                                            item.fname === file.fname && item.orderno === file.orderno
                                                                        )}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell>
                                                                    {retryCount}/3
                                                                    {exceededLimit && (
                                                                        <Typography variant="caption" style={{color: 'red', display: 'block', 
                                                                         whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                                                            Max retries exceeded
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                            <Button
                                onClick={handleRetryDownload}
                                style={{
                                    backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file)) 
                                        ? '#1976d2' : '#f44336',
                                    color: 'white'
                                }}
                                variant="contained"
                                disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                            >
                                Retry Download
                            </Button>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                            </DialogActions>
                        </Dialog> */}
                        <Dialog
                            // open={props.showFailedFilesDialog && props.failedFiles.length > 0}
                            open={props.showFailedFilesDialog && props.failedFiles.length > 0 && stfFailedFiles.length === 0}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedFailedFiles.length === props.failedFiles.length}
                                                        onChange={handleSelectAllFailedFiles}
                                                        color="primary"
                                                    />
                                                }
                                                label="Select All"
                                            />
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                Total: {props.failedFiles?.length}
                                            </Typography>
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell>Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item => item.fname === file.fname && item.orderno === file.orderno)}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell>
                                                                    {retryCount}/3
                                                                    {exceededLimit && (
                                                                        <Typography variant="caption" style={{ color: 'red', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            Max retries exceeded
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleRetryDownload}
                                    style={{
                                        backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file))
                                            ? '#1976d2' : '#f44336',
                                        color: 'white'
                                    }}
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                                >
                                    Retry Download
                                </Button>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={props.showFailedFilesDialog && stfFailedFiles.length > 0}  // Show dialog only if there are STL files
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    STL Files - Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {stfFailedFiles && stfFailedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        {/* <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'green' }}>
                                                STL files available for: {selectedRowsArray.length} orders
                                            </Typography>
                                        </Box>

                                        <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                STL files not available for: {stfFailedFiles.length} orders
                                            </Typography>
                                        </Box> */}
                                        <Box 
                                                style={{ 
                                                    border: '1px solid #e0e0e0', 
                                                    borderRadius: '4px', 
                                                    padding: '12px', 
                                                    marginBottom: '8px' 
                                                }}
                                        >
                                                <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                    <Typography variant="subtitle1" color="textSecondary">
                                                        {/* STL files available for: {caseCount ?? 0} orders */}
                                                        Below files are not available. Please contact support team
                                                    </Typography>
                                                    {/* <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                                        Total: {stfFailedFiles.length}
                                                    </Typography> */}
                                                </Box>
                                                
                                                {/* <Typography variant="subtitle1" color="textSecondary">
                                                    STL files not available for: {selectedRowsArray.length - (caseCount ?? 0)} orders
                                                </Typography> */}
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stfFailedFiles.map((file, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                        
                        <Dialog
                            open={openRe}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined"
                                                defaultValue="0"
                                                onChange={(event) => setPtype(event.target.value as string)}
                                                value={ptype}
                                            >
                                                <MenuItem value="Design" disabled>Design</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicatePtype(props.redesignReasons).map((proType, indexRe1) => (
                                                    proType!.producttype !== 'Model' ? <MenuItem id={proType!.rowno} value={proType!.producttype}>{proType!.producttype}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtype(event.target.value as string)}
                                            value={ptype}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-1"
                                                defaultValue="0"
                                                onChange={(event) => setCategory(event.target.value as string)}
                                                value={category}
                                            >
                                                <MenuItem value="0" disabled>Select Category</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cate, indexRe1) => (
                                                    cate!.producttype !== 'Model' ? <MenuItem id={cate!.rowno} value={cate!.category}>{cate!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                            typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                                <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`category${indexRe1}`}
                                                                checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                                value={cate!.category}
                                                                onChange={changeDesignCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cate!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }

                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-3"
                                                defaultValue="0"
                                                onChange={(event) => setPtypeModel(event.target.value as string)}
                                                value={ptypeModel}
                                            >
                                                <MenuItem value="Model" disabled>Model</MenuItem>
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtypeModel(event.target.value as string)}
                                            value={ptypeModel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-4"
                                                defaultValue="0"
                                                onChange={(event) => setCategoryModel(event.target.value as string)}
                                                value={categoryModel}
                                            >
                                                <MenuItem value="0" disabled>Select Category (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cateModel, indexRe1) => (
                                                    cateModel!.producttype === 'Model' ? <MenuItem id={cateModel!.rowno} value={cateModel!.category}>{cateModel!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                            typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                                <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`categoryModel${indexRe1}`}
                                                                checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                                value={cateModel!.category}
                                                                onChange={changeModelCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cateModel!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }
                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-6"
                                                defaultValue="Next Day 7 AM"
                                                onChange={(event) => setTat(event.target.value as string)}
                                                value={tat}
                                            >
                                                {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                    <MenuItem key={index1} id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-red1"
                                                id="demo-simple-select-outlined-red1"
                                                required
                                                fullWidth
                                                onChange={(event) => saveManufactType(event.target.value as string)}
                                                value={manufactType}
                                            >
                                                <MenuItem disabled value="">
                                                    <em>Destination</em>
                                                </MenuItem>
                                                <MenuItem value="In-House">
                                                    In-House
                                                </MenuItem>
                                                {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactTypes) => (
                                                    <MenuItem key={manufactTypes.rowno} id={manufactTypes.rowno} value={manufactTypes.dest}>{manufactTypes.dest}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                // rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsg(event.target.value as string)}
                                                value={msg}
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: 'space-between' }}>
                                <Typography variant="caption">
                                    *Please select Reason, TAT, Destination and enter Remarks to submit Re-Design.
                                </Typography>
                                <div className={classes.modal}>
                                    <Button size="small" onClick={handleCloseRe} color="secondary">
                                        Cancel
                                    </Button>
                                    <Button
                                        size="small"
                                        disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                        onClick={handleSubmitRe}
                                        color="primary"
                                    >
                                        Re-Design
                                    </Button>
                                </div>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDesignReason}
                            onClose={onCloseDesignReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-2"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeDesignReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                            reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                                <MenuItem key={indexRe1} id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openModelReason}
                            onClose={onCloseModelReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-5"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeModelReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                            reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                                <MenuItem key={indexRe1} id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openAppro}
                            onClose={handleCloseApp}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsgApp(event.target.value as string)}
                                                value={msgApp}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseApp} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitApp} disabled={msgApp === ''} color="primary">
                                    Approve
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthDownload}
                            maxWidth={maxWidthDownload}
                        // maxWidth={!downIndi ? maxWidthDownload : 'md'}
                        >
                            <DialogTitle id="form-dialog-title">{!downIndi ? 'What to download?' : 'Download As'}</DialogTitle>
                            {!downIndi ?
                                <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        {
                                            downloadFiletypes.map((typeFile, indexRe1) => (
                                                <Grid item key={indexRe1} xs={6} sm={4} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`filetype${indexRe1}`}
                                                                checked={fileTypes.indexOf(typeFile) > -1}
                                                                value={typeFile}
                                                                onChange={filetypeChange}
                                                                name="Filetype"
                                                            />
                                                        }
                                                        label={typeFile}
                                                    />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </DialogContent>
                                // : <DialogContent dividers>
                                //     <Grid container spacing={2}>
                                //         <RadioGroup aria-label="down-type" name="download-type" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                //             <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" />
                                //             <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                //         </RadioGroup>
                                //     </Grid>
                                // </DialogContent>
                                : <DialogContent dividers>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <RadioGroup 
                                      aria-label="down-type" 
                                      name="download-type" 
                                      value={downloadType} 
                                      onChange={(e) => setDownloadType(e.target.value)}
                                    >
                                      {/* <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> */}
                                      {selectedRowsArray && selectedRowsArray.length <= 10 && ( 
                                        <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> 
                                     )}
                                      <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                    </RadioGroup>
                                  </Grid>
                                  
                                  {/* {selectedRowsArray && selectedRowsArray.length > 0 && (
                                    <Grid item xs={12}>
                                      <Box 
                                        p={2} 
                                        mt={1}
                                        border={1} 
                                        borderColor="divider" 
                                        borderRadius="borderRadius" 
                                        bgcolor="background.paper"
                                      >
                                        <Typography variant="subtitle2" gutterBottom>
                                          Selected Files: {selectedRowsArray.length}
                                          Total Size: {calculateTotalFileSize(selectedRowsArray)}
                                        </Typography>
                                        
                                        <Typography variant="body2" color="textSecondary">
                                          Total Size: {calculateTotalFileSize(selectedRowsArray)}
                                        </Typography>
                                       
                                      </Box>
                                    </Grid>
                                  )} */}
                                  
                                    {selectedRowsArray && selectedRowsArray.length > 0 && (
                                        <Grid item xs={12}>
                                        <Box 
                                            p={2} 
                                            mt={1}
                                            border={1} 
                                            borderColor="divider" 
                                            borderRadius="borderRadius" 
                                            bgcolor="background.paper"
                                        >
                                            <Typography variant="subtitle2" gutterBottom>
                                            Selected Files: {selectedRowsArray.length}
                                            </Typography>
                                            
                                            {/* <Typography variant="body2" color="textSecondary">
                                            Total Size: {calculateTotalFileSize(selectedRowsArray)}
                                            </Typography> */}
                                            {selectedRowsArray.length <= 5 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 3 - 5 Mins (approx)
                                            </Typography>
                                            ) : selectedRowsArray.length > 5 && selectedRowsArray.length <= 25 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 8 - 10 Mins (approx)
                                            </Typography>
                                            ) : selectedRowsArray.length > 25 && selectedRowsArray.length <= 50 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 15 - 18 Mins (approx)
                                            </Typography>
                                            ) : (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 20 - 25 Mins (approx)
                                            </Typography>
                                            )}
                                        </Box>
                                        </Grid>
                                    )}
                                </Grid>
                              </DialogContent>

                            }
                            <DialogActions>
                                {downloadType === 'single' && downIndi && <Typography variant="caption" >
                                    *Note: If selected file size exceeding 1 GB might not download properly, consider downloading as Individual files.
                                </Typography>}
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {!downIndi && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                                {downIndi && <Button size="small" onClick={() => submitZipDownload()} color="primary">
                                    OK
                                </Button>}
                            </DialogActions>
                        </Dialog>
                        {/* <StyledMenu
                            id="customized-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <StyledMenuItem>
                                <ListItemIcon>
                                    <PictureAsPdfIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="PDF" />
                            </StyledMenuItem>
                            <StyledMenuItem>
                                <ListItemIcon>
                                    <InsertDriveFileIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="CSV" />
                            </StyledMenuItem>
                            <StyledMenuItem>
                                <ListItemIcon>
                                    <AssignmentIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="EXCEL" />
                            </StyledMenuItem>
                        </StyledMenu> */}
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Completed Orders"
                        columns={state.columns}
                        data={props.completeOrderData}
                        localization={{
                            toolbar: {
                                nRowsSelected: `${selectedRowsArray.length} order(s) selected`,
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '5px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            sorting: false,
                            exportButton: true,
                            exportAllData: true,
                            selectionProps: (selecrowData: RowDataCompleted) => {
                                const checked = (selectedRowsArray.find(_d => _d.orderno === selecrowData.orderno)?.orderno) ? { checked: true } : { checked: false };
                                return {
                                    ...checked
                                };
                            }
                        }}
                        onSelectionChange={
                            (rows, rowData) => {
                                if (!rowData) {
                                    handleSelectAll(rows);
                                } else {
                                    handleSelectOne(rowData);
                                }
                            }
                        }
                        onChangePage={
                            (pageno) => {
                                // setSelectedRowsArray([]);
                                setPage(pageno);
                            }
                        }
                        onChangeRowsPerPage={
                            (pageSize) => {
                                // setSelectedRowsArray([]);
                                if (pageSize !== size) {
                                    if (pageSize > size) {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.completeOrderData.length / 5), 0)));
                                    } else {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.completeOrderData.length / 5), 0)));
                                    }
                                }
                                setSize(pageSize);
                            }
                        }
                        // onRowClick={(event, rowData) => {
                        //     props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid));
                        // }}
                        actions={[
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download Zip
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'zip');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download STL/PTS/3OX
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'stl');
                                    }
                                }
                            }
                            // {
                            //     tooltip: 'Download All files',
                            //     icon: 'view_column',
                            //     isFreeAction: true,
                            //     onClick: (evt, data) => {
                            //         if (!props.isDownloading) {
                            //             props.onBulkDownload(props.completeOrderData);
                            //         }
                            //     }
                            // }
                        ]}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', padding: '10px 5px' }}>
                            <div style={{ width: '20px', height: '20px', background: 'red', borderRadius: '50%', padding: '5px' }} />
                            <div style={{ padding: '0 10px' }}>
                                - Not yet Downloaded
                            </div>
                            <div style={{ width: '20px', height: '20px', background: 'green', borderRadius: '50%', padding: '5px' }} />
                            <div style={{ padding: '0 10px' }}>
                                - Downloaded
                            </div>
                        </div>
                        {props.userInfo.labCode === '05033' && <div style={{ display: 'flex', padding: '10px 5px' }}>
                            <a href={`/assets/printclient/MLCETEC3DPrint Installer.zip`} target="_blank">To 3D print online, click here to install the print client</a>
                        </div>}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default CompleteOrderPageViewDate;



// WEBPACK FOOTER //
// ./src/components/layouts/CompleteOrderPageView.tsx